import "../css"
import "fancybox/dist/js/jquery.fancybox"
import "fancybox/dist/css/jquery.fancybox.css"
import Galleria from "galleria"
import theme from "./galleria.classic"

$(function() {
  $(".fancybox").fancybox()

  let el = $("#galleria")
  if (el.length > 0) {
    // Galleria.loadTheme doesn't work with webpack so initialize manually
    let galleria = new Galleria().init(el, { height: 0.44 })
    galleria.theme = theme
    galleria._init.call(galleria)
    el.data("galleria", galleria)
  }
})

addEventListener("keydown", e => {
  if (e.target.closest("body.slideshow")) {
    e.preventDefault()

    if (e.key == "ArrowLeft")
      Galleria.get(0).prev()
    else if (e.key == "ArrowRight")
      Galleria.get(0).next()
  }
})

addEventListener("click", e => {
  if (e.target.closest("#slide_in_new_window")) {
    e.preventDefault()
    window.open(Galleria.get(0).getData().original.dataset.imageUrl, "_blank")
  }
})
